export default __webpack_public_path__ + "static/thumb-landscape-60172c2761f68cdf8b9f4a94908e79d3.jpg";